import styled from '@emotion/styled';
import Info from '@engineering/icons/info';
import { Ui } from '@silvertours/front-shared';
import { css } from '@emotion/react';

const Wrapper = styled.div`
  grid-area: age;
  padding-left: 1rem;
  display: grid;
  grid-template:
    'icon label input' 2rem
    '. error error' 1fr / 2rem min-content auto;
  gap: 0 0.5rem;
  align-items: center;

  @media (min-width: 634px) {
    padding-top: 0.75rem;
  }
`;

const StyledIcon = styled(Info)`
  fill: ${({ theme }) => theme.color.button};
  width: 2rem;
  grid-area: icon;
  vertical-align: bottom;
  cursor: pointer;
`;

const StyledLabel = styled.label`
  grid-area: label;
  line-height: 1.5;
  text-wrap: nowrap;
`;

const StyledInput = styled.input<{
  $isInvalid?: boolean;
}>`
  grid-area: input;
  margin: 0;
  padding: 0 0.5rem;
  width: 3.5625rem;
  justify-self: start;
  height: min-content;
  border: ${({ theme, $isInvalid }) =>
    `1px solid ${$isInvalid ? theme.color.error : theme.color.grey03}`};
  border-radius: ${({ theme }) => theme.borderRadius.xs};
  outline: 0;
  font-size: 0.875rem;
  font-family: inherit;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.text};
  background-color: ${({ theme }) => theme.color.white};

  ${({ theme, $isInvalid }) =>
    !$isInvalid &&
    css`
      &:hover,
      &:focus {
        border-color: ${theme.color.grey02};
      }
    `}

  &::placeholder {
    color: ${({ theme }) => theme.color.grey01};
    opacity: 1;
  }

  &:focus::placeholder {
    color: transparent;
  }

  &::-ms-clear {
    display: none;
  }

  &[readonly],
  &[disabled] {
    border-color: ${({ theme }) => theme.color.grey03};
    color: ${({ theme }) => theme.color.grey03};
    cursor: not-allowed;
    pointer-events: none;
  }
`;

const StyledError = styled(Ui.ErrorMessage)`
  grid-area: error;
  margin: 0;
  padding: 0;
  line-height: 1.2;
  text-wrap: pretty;
`;

const StyledTooltip = styled(Ui.Tooltip)`
  border-radius: 100%;
`;

export {
  Wrapper,
  StyledIcon,
  StyledLabel,
  StyledInput,
  StyledError,
  StyledTooltip,
};
